import React from 'react';
import PropTypes from 'prop-types';
import './svg.css';


const ParkingLotIcon = props => {
  const { fill, className } = props;
  return (
    <svg
      viewBox="2 4 22 22"
      height="18px"
      width="18px"
    // className='svg'
    >
      <path d="M20.9447231,8.81105186 C24.8671111,12.6035097 25.0345524,18.842876 21.3212298,22.8408229 C19.6087987,24.6861215 17.2628579,25.814661 14.7541206,26 L14.7541206,21.9742657 C17.8983364,21.5775762 20.1928827,18.8014812 19.9944262,15.6341945 C19.7959697,12.4669078 17.1728942,9.99980683 14.0038225,9.99980683 C10.8347507,9.99980683 8.21167524,12.4669078 8.01321874,15.6341945 C7.81476224,18.8014812 10.1093085,21.5775762 13.2535244,21.9742657 L13.2535244,25.9994991 C9.35479418,25.7056848 5.98426245,23.1643642 4.62465332,19.4934846 C3.26504419,15.822605 4.16554256,11.6949538 6.93001192,8.9263182 C10.7896662,5.06985566 17.022335,5.01859403 20.9447231,8.81105186 Z M14.5040212,13.0046471 C15.3081883,13.0046471 16.0512693,13.4342666 16.4533529,14.1316723 C16.8554364,14.829078 16.8554364,15.6883173 16.4533529,16.3857229 C16.0512693,17.0831286 15.3081883,17.5127482 14.5040212,17.5127482 L13.7537231,17.5127482 L13.7537231,18.2640984 C13.7537231,18.6790577 13.4178032,19.0154486 13.003425,19.0154486 C12.5890468,19.0154486 12.2531269,18.6790577 12.2531269,18.2640984 L12.2531269,13.7559972 C12.2531269,13.341038 12.5890468,13.0046471 13.003425,13.0046471 L14.5040212,13.0046471 Z M14.5040212,14.5073474 L13.7537231,14.5073474 L13.7537231,16.0100478 L14.5040212,16.0100478 C14.9183994,16.0100478 15.2543193,15.6736569 15.2543193,15.2586976 C15.2543193,14.8437384 14.9183994,14.5073474 14.5040212,14.5073474 Z" id="Combined-Shape" fill={fill ? fill : "#000"}></path>
    </svg>
  );
};

// ParkingLotIcon.propTypes = {
//   active: PropTypes.bool.isRequired,
//   label: PropTypes.bool.isRequired,
// };

export default ParkingLotIcon;
